var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-icon.ts
import "@adornis/ass/style.js";
import "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20,400,0..1,0";
import "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20,700,0..1,0";
import "https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20,400,0..1,0";
import "https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20,700,0..1,0";
import "https://fonts.googleapis.com/css2?family=Material+Symbols+Sharp:opsz,wght,FILL,GRAD@20,400,0..1,0";
import "https://fonts.googleapis.com/css2?family=Material+Symbols+Sharp:opsz,wght,FILL,GRAD@20,700,0..1,0";
import { customElement } from "lit/decorators.js";
import { ChemistryLiteElement } from "../../chemistry-lite-element.js";
var fonts = {
  "material-outlined": "Material Symbols Outlined",
  "material-rounded": "Material Symbols Rounded",
  "material-sharp": "Material Symbols Sharp",
  img: "Image"
};
var XIcon = class extends ChemistryLiteElement {
  styles() {
    return [
      {
        // style from here: https://google.github.io/material-design-icons/
        fontSize: "1em",
        fontStyle: "normal",
        display: "block",
        lineHeight: "1",
        textTransform: "none",
        letterSpacing: "normal",
        wordWrap: "normal",
        whiteSpace: "nowrap",
        direction: "ltr",
        fontFamily: "'Material Symbols Outlined'",
        boxSizing: "content-box",
        maxWidth: "1em",
        userSelect: "none",
        // fontWeight: 'normal',
        /* Support for all WebKit browsers. */
        WebkitFontSmoothing: "antialiased",
        /* Support for Safari and Chrome. */
        textRendering: "optimizeLegibility",
        /* Support for Firefox. */
        MozOsxFontSmoothing: "grayscale",
        /* Support for IE. */
        fontFeatureSettings: "liga",
        verticalAlign: "bottom",
        fontVariationSettings: "'FILL' 1,'wght' 400,'GRAD' 0,'opsz' 20",
        // only relevant for type=img
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        "&[size=xxs]": { fontSize: ".3em" },
        "&[size=xs]": { fontSize: ".5em" },
        "&[size=sm]": { fontSize: ".7em" },
        "&[size=md]": { fontSize: "1em" },
        "&[size=lg]": { fontSize: "1.3em" },
        "&[size=xl]": { fontSize: "2em" }
      }
    ];
  }
  constructor() {
    super();
    this.initFont();
  }
  get outlined() {
    return this.getAttribute("outlined") !== null;
  }
  initFont() {
    const fontType = this.getAttribute("type") || "material-outlined";
    if (!Object.keys(fonts).includes(fontType))
      throw new Error(`X-ICON:: ${fontType} given. Only allowed types are: ${Object.keys(fonts).join(", ")}`);
    if (fontType !== "img") {
      this.style.fontFamily = `'${fonts[fontType]}'`;
      this.style.fontWeight = "500";
      this.style.fontVariationSettings = `'FILL' ${this.outlined ? "0" : "1"},'wght' 400,'GRAD' 0,'opsz' 20`;
    } else {
      const imgSrc = this.getAttribute("src");
      if (!imgSrc)
        return console.warn("X-ICON:: No 'src' given for img type icon");
      this.style.backgroundImage = `url('${imgSrc}')`;
      this.style.width = "1em";
      this.style.height = "1em";
    }
  }
  static get observedAttributes() {
    return ["type", "src", "outlined"];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if ((name === "type" || name === "src" || name === "outlined") && oldValue !== newValue)
      this.initFont();
  }
};
XIcon = __decorateClass([
  customElement("x-icon")
], XIcon);
export {
  XIcon
};
